<script lang="ts" setup>
defineEmits<{ (e: 'clickMenu'): void }>()

const { status } = useAuth()
const isMobileScreen = useIsMobileScreen()
const { accessCodeSession, terminateSession } = useCustomerModuleAccessCodeSession()

const route = useRoute()

const { hasAnyAssignedRole } = useAuthorization()
const isPartnerSalesUser = hasAnyAssignedRole(['partnerSales'], false)
const isExternalProjectContractor = hasAnyAssignedRole(['externalServiceProjectContractor'], false)

const displayShopBuyPageNavigationButton = computed(() => route.path.startsWith('/my-hos/machinery') && isPartnerSalesUser.value)

const { sale: saleIcon } = useBrandIcons()
</script>

<template>
  <div class="fixed top-0 w-screen bg-hos-blue-dark py-4 border-b border-white/10 z-30">
    <div class="flex items-center gap-4 justify-between">
      <NuxtLink to="/my-hos">
        <img v-if="!isMobileScreen" src="/branding/Logo-Hanselmann-ohne Slogan_weiss.png" class="h-8">
        <img v-else src="/branding/hanselmann-forklift.svg" class="h-8 object-contain">
      </NuxtLink>

      <div class="flex items-center gap-2">
        <NuxtLink v-if="displayShopBuyPageNavigationButton" to="/shop/buy">
          <n-popover trigger="hover">
            <template #trigger>
              <n-button type="primary">
                <template #icon>
                  <Icon :name="saleIcon" />
                </template>
                {{ $t('customerModule.navigation.shop.buy.button.label') }}
              </n-button>
            </template>
            <span>{{ $t('customerModule.navigation.shop.buy.button.hover.text') }}</span>
          </n-popover>
        </NuxtLink>

        <NuxtLink v-if="isExternalProjectContractor" to="/">
          <n-button type="primary">
            <template #icon>
              <Icon name="material-symbols:open-in-new-rounded" />
            </template>
            <span>{{ $t('customerModule.navigation.toServiceProjects') }}</span>
          </n-button>
        </NuxtLink>

        <CustomerModuleLayoutLanguageSelector :display-text="!isMobileScreen" />

        <!-- Regular authenticated user -->
        <template v-if="status === 'authenticated'">
          <CustomerModuleLayoutUserDropdown />
          <n-button type="primary" icon-placement="right" @click="$emit('clickMenu')">
            <template #icon>
              <Icon name="material-symbols:menu" />
            </template>
            <template v-if="!isMobileScreen">
              {{ $t('customerModule.navigation.menu.title') }}
            </template>
          </n-button>
        </template>

        <!-- Access code session user -->
        <template v-else-if="accessCodeSession">
          <n-button type="primary" secondary color="white" icon-placement="right" @click="terminateSession">
            <template v-if="isMobileScreen" #icon>
              <Icon name="material-symbols:logout-rounded" />
            </template>
            <template v-if="!isMobileScreen">
              {{ $t('customerModule.navigation.logout.title') }}
            </template>
          </n-button>
        </template>

        <!-- Neither -->
        <NuxtLink v-else to="/auth/login">
          <n-button type="primary">
            <template #icon>
              <Icon name="material-symbols:login" />
            </template>
            {{ $t('customerModule.navigation.login.title') }}
          </n-button>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>
